import { render } from "./MiningEarnings.vue?vue&type=template&id=bbc00ecc&scoped=true"
import script from "./MiningEarnings.vue?vue&type=script&lang=js"
export * from "./MiningEarnings.vue?vue&type=script&lang=js"

import "./MiningEarnings.vue?vue&type=style&index=0&id=bbc00ecc&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc00ecc"]])

export default __exports__